import { useEffect } from "react";
import { useToast } from "@chakra-ui/react";
import { supabase } from "../utils/supabaseClient";
import useBusinessGuard from "../hooks/useBusinessGuard";

/**
 * RedemptionToastListener.jsx
 * Listens for new flyer redemptions and triggers ROI toast + inserts notification.
 * Hydration-safe and scoped to businessId.
 */
export default function RedemptionToastListener() {
  const toast = useToast();
  const { businessId, loading: authLoading } = useBusinessGuard();

  useEffect(() => {
    if (authLoading || !businessId) return;

    const channel = supabase
      .channel("redemptions")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "redemptions",
          filter: `business_id=eq.${businessId}`,
        },
        async (payload) => {
          const redemption = payload.new;

          toast({
            title: `🎉 Redemption in ${redemption.postcode_sector}`,
            description: `A flyer was redeemed in ${redemption.postcode_sector}. ROI updated.`,
            status: "success",
            duration: 6000,
            isClosable: true,
          });

          const { error } = await supabase.from("notifications").insert({
            business_id: redemption.business_id,
            campaign_id: redemption.campaign_id,
            postcode: redemption.postcode_sector,
            type: "referral_unlocked",
            message: `Referral unlocked a slot in ${redemption.postcode_sector}. Share more to earn extra reach.`,
            region: redemption.region,
            group_id: redemption.group_id,
          });

          if (error) {
            console.error("Notification insert failed:", error);
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [authLoading, businessId, toast]);

  return null;
}
